<div class="tab-pane fade spk-tab-pane" [ngClass]="class" id="{{name}}" role="tabpanel" attr.aria-labelledby="{{name}}">
  <br />
  <ng-content></ng-content>
</div>
